module.exports = __webpack_public_path__ + "static/img/color.8673e243.jpg";